export class RouteModel {
  Type?: number;
  Url?: string;
  RedirectTo?: string;
}
